import { getCurrentDate,getCurrentDateOfBelow } from "../../services/DateServices";

export const reportObj = {
    CustomerContract:"",
    VesselName:"",
    Dispatchport:"",
    BunkeredDate:"", 
    Status:"",
    pdfFileName:"",
    SampleList:[]
}
export const reportFualObjSample =  {
    SampleID:"",
    ProductType:"",
    SupplierName:"",
    Parameters:"",
    Limits:"",
    TestResults:"",
    BunkeredPort:"", 
    BunkeredDate:"",
    ReportDate:"",
    pdfFileName:"",
    Flag:""
}
export const reportLubeObjSample =  {
    SampleID:"",
    ReportsDescription:"",
    ReportType:"",
    Make:"",
    Model:"",
    LOTypeBrand:"",
    ReportDate:"",
    pdfFileName:"",
    Flag:""
}
export const reportTotObjSample =  {
    SampleID:"",
    ReportsDescription:"",
    ReportType:"",
    ReportDate:"",
    pdfFileName:"",
    Flag:""
}
export const sampleObj = {
    CustomerContract:"",
    VesselName:"",
    Dispatchport:"",
    SampledDate:"", 
    Status:"",
    pdfFileName:"",
    SampleList:[],
    CustomerName:"",
}
export const sampleFualObjSample =  {
    SampleNumber:"",
    BunkerPort:"",
    FuelGrade:"",
    ReportType:"",
    SampledDate:"",
    ArrivedDate:"",
    AnalysedDate:"",
    ReportedDate:"",
    Status:"",
    Vessel_Name:"",
}
export const sampleLubeObjSample =  {
    SampleID:"",
    EquipmentDescription:"",
    ServiceType:"",
    SampledDate:"",
    ArrivedDate:"",
    AnalysedDate:"",
    ReportedDate:"",
    Status:""
}
export const sampleTotObjSample =  {
    SampleNumber:"",
    AssetName:"",
    ServiceType:"",
    SampledDate:"",
    ArrivedDate:"",
    AnalysedDate:"",
    ReportedDate:"",
    Status:""
}

export const reportFilterFuel =  {
    contract:"",
    vessel:"",
    bunkerPort:"",
    bunkeredFromDate:getCurrentDateOfBelow(30),
    bunkeredToDate: getCurrentDate(),
    sampledFromDate:"",
    sampledToDate:"",
    sampleNumber:"",
    reportType:"",
    statusType:""
}
export const  reportFilterLube = {
    vessel: '',
    equipmentName: "",
    equipmentMake: "",
    equipmentModel: "",
    reportedFromDate:  getCurrentDateOfBelow(30),
    reportedToDate: getCurrentDate(),
    sampledFromDate: "",
    sampledToDate: "",
    reportType: "",
    statusType:""
  }
  export const  reportFilterTot = {
    transformer: "",
    location: "",
    contract: "",
    rating: "",
    voltage: "",
    reportedFromDate:  getCurrentDateOfBelow(30),
    reportedToDate: getCurrentDate(),
    sampledFromDate: "",
    sampledToDate: "",
    statusType: "",
    sampleNumber:""
  }
  export const  sampleFilterFual = {
      contract: "",
      vessel: "",
      bunkerPort: "",
      bunkeredFromDate: "",
      bunkeredToDate: "",
      sampledFromDate: getCurrentDateOfBelow(90),
      sampledToDate: getCurrentDate(),
      sampleNumber: "",
      reportType: "",
      statusType: ""
  }
  export const  sampleFilterLube = {
    contract: "",
    vessel: "",
    location : "",
    equipmentName: "",
    equipmentMake: "",
    equipmentModel: "",
    reportedFromDate:"",
    reportedToDate: "",
    sampledFromDate: getCurrentDateOfBelow(180),
    sampledToDate: getCurrentDate(),
    reportType: "",
    statusType:""
  }
  export const  sampleFilterTOT = {
    transformer:"",
    location:"",
    contract: "",
    rating: "",
    voltage: "",
    reportedFromDate:"",
    reportedToDate:"",
    sampleNumber:"",
    sampledFromDate:getCurrentDateOfBelow(730),
    sampledToDate:getCurrentDate(),
    statusType:""
  }